import { useEffect } from 'react';
import AdSenseBanner from '@/components/AdSenseBanner';
import { useSession } from 'next-auth/client';

const InArticleAdSense = props => {
  const [session] = useSession();
  // re-render on session change
  useEffect(() => {}, [session]);

  const isProUser = session && session.user.isProUser === 'true';
  const isPremiumUser = session && session.user.isPremiumUser === 'true';
  const isSubscriptionUser = isProUser || isPremiumUser;
  const showAds = !session || !isSubscriptionUser;

  if (showAds) {
    return <AdSenseBanner {...props} />;
  }
  return <div />;
};

export default InArticleAdSense;
